const isFile = (u: string) => /\.(mp4|webm|ogg|mov|avi)(\?.*)?$/i.test(u);

function embedUrl(u: string) {
  const yt = u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0`;
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null; // anything else is never dropped into an iframe
}

/** Event video: an uploaded / direct file plays natively, YouTube and Vimeo links are embedded. */
export function EventVideo({ src, title, caption }: { src: string; title: string; caption?: string | null }) {
  const embed = isFile(src) ? null : embedUrl(src);
  if (!isFile(src) && !embed) return null;
  return (
    <figure>
      <div className="aspect-[400/250] w-full overflow-hidden rounded-[var(--radius-card)] border border-line bg-black shadow-soft">
        {embed ? (
          <iframe
            src={embed}
            title={`${title} video`}
            loading="lazy"
            allow="accelerometer; encrypted-media; picture-in-picture"
            allowFullScreen
            className="h-full w-full border-0"
          />
        ) : (
          <video src={src} controls controlsList="nodownload noremoteplayback" disablePictureInPicture onContextMenu={(e) => e.preventDefault()} preload="metadata" className="h-full w-full" />
        )}
      </div>
      {caption && <figcaption className="mt-2 text-center text-sm text-ink-soft">{caption}</figcaption>}
    </figure>
  );
}
